import { useState, useRef, useEffect, useCallback } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBackend } from '../context/BackendContext';
import Burger from '../Burger';
import './Header.css';
import exp8Logo from '../svg/WebClient-Express8-Logo-Text-Web.svg';
import aaxLogo from '../svg/WebClient-ArchivX-Logo-Text-Web.svg';
import webClientLogo from '../svg/WebClient-Logo-Text-Web.svg';

import { ViewProps, HeaderProps } from '../interfaces';

function Header() {
  const { logout } = useAuth();
  const backend = useBackend();
  const navigate = useNavigate();
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLUListElement>(null);

  const [navState, setNavState] = useState('nav_hidden');

  const toggleNav = () => {
    setNavState((prev) => (prev === 'nav_hidden' ? 'nav_visible' : 'nav_hidden'));
    if (navState === 'nav_hidden') {
      setFocusedIndex(0);
    } else {
      setFocusedIndex(null);
    }
  };

  let buttons = [
    { id: 1, text: 'Textbausteine', link: 'textbausteine', class: 'menu-button' },
    { id: 2, text: 'Passwort ändern', link: 'passwort', class: 'menu-button' }
  ];

  if (window.innerWidth < 1200) {
    buttons = [
      { id: 1, text: 'Passwort ändern', link: 'passwort', class: 'menu-button' }
    ];
  }

  function handleButtonKeyDown(event:React.KeyboardEvent<HTMLButtonElement >) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setNavState('nav_visible');
      setFocusedIndex(0);
    }
  }

  const handleMenuKeyDown = (e: React.KeyboardEvent<HTMLUListElement>) => {
    if (e.key === 'Escape') {
      setNavState('nav_hidden');
      setFocusedIndex(null);
      buttonRef.current?.focus();
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setFocusedIndex((prev) => (prev === null || prev === buttons.length ? 0 : prev + 1));
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setFocusedIndex((prev) => (prev === null || prev === 0 ? buttons.length : prev - 1));
    }

    if (e.key === 'Tab') {
      setNavState('nav_hidden');
      setFocusedIndex(null);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setNavState('nav_hidden');
        setFocusedIndex(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (focusedIndex !== null && menuRef.current) {
      const item = menuRef.current.children[focusedIndex].children[0] as HTMLButtonElement;
      item?.focus();
    }
  }, [focusedIndex]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header role="banner">
      <img className="logo" src={webClientLogo} alt="Logo AUGIAS-WebClient" />
      <nav role="navigation" aria-label="Profil-Menü" className="nav">     
        <ul role="menubar" className="nav-buttons">     
          <li role="menuitem">
            <button 
              ref={buttonRef}
              className="nav-button profil onlyOutsideBurger" 
              aria-haspopup="true"
              aria-expanded={navState === 'nav_visible'}
              aria-controls="profil-menu"
              onClick={() => toggleNav()} 
              onKeyDown={(e) => handleButtonKeyDown(e)}
            > 
              Profil 
            </button>
            <ul 
              id="profil-menu"
              ref={menuRef} 
              role="menu" 
              className={navState === 'nav_visible' ? 'menu_open' : 'menu_closed'} 
              onKeyDown={handleMenuKeyDown}
            >
              {buttons.map((button) => (
                <li key={button.id} role="menuitem">
                  <NavLink 
                    to={'/' + button.link} 
                    className={({ isActive }) => (isActive ? 'menu-button-active' : 'menu-button')}
                  >
                    {button.text}
                  </NavLink>
                  {/*
                  <button 
                    onClick={() => changeView(button.changeView)} 
                    className={button.class}
                  >
                    {button.text}
                  </button>
                  */}         
                </li>
              ))}
              <li role="menuitem">
                <button 
                  onClick={handleLogout} 
                  className="abmelden"
                >
                  abmelden
                </button>
              </li>
            </ul>
          </li>         
        </ul>
      </nav> 
      { /*
      <nav role="navigation" aria-label="Profil-Menü" className="nav-responsive">     
        <ul role="menubar" className="nav-buttons">   
          <li role="menuitem">
            <button 
              ref={buttonRef} 
              className="nav-button-responsive" 
              aria-haspopup="true"
              aria-expanded={navState === 'nav_visible'}
              aria-controls="profil-menu"
              onClick={() => toggleNav()}
              onKeyDown={(e) => handleButtonKeyDown(e)}
            > 
              Profil 
            </button>
            <ul 
              id="profil-menu"
              ref={menuRef} 
              role="menu" 
              className={navState === 'nav_visible' ? 'menu_open' : 'menu_closed'} 
              onKeyDown={handleMenuKeyDown}
            >
              {buttonsResponsive.map((button) => (
                <li key={button.id} role="menuitem">
                  <button 
                    onClick={() => changeView(button.changeView)} 
                    className={button.class}
                  >
                    {button.text}
                  </button>
                </li>
              ))}
            </ul>
          </li> 
                  
        </ul>
      </nav>
      */ }
    </header>
  );
}

export default Header;
